import { Controller } from '@hotwired/stimulus'
import { patch } from '@rails/request.js'
import Sortable from 'sortablejs'

function countPreviousSiblings(el) {
  let count = 0; let
    prev
  // eslint-disable-next-line no-cond-assign
  while (prev = el.previousElementSibling) {
    count++
    el = prev
  }

  return count
}

export default class ReorderController extends Controller {
  static values = {
    topPosition: Number,
    url: String,
  }

  connect() {
    // If the immediate element is a Turbo frame, make it the Sortable root.
    const first = this.element.children[0]
    if (first && first.tagName.toLowerCase() === 'turbo-frame') {
      this.root = first
    } else {
      this.root = this.element
    }

    this.sortable = new Sortable(this.root, {
      ghostClass: '!bg-gray-100',
      handle: '.handle',
      onUpdate: this.save,
    })
  }

  disconnect() {
    this.#destroySortable()
  }

  save = async (e) => {
    this.#destroySortable()
    this.element.classList.add('opacity-50', 'select-none')

    const el = e.item
    const url = el.dataset.reorderTarget
    if (!url) return

    const position = this.topPositionValue + countPreviousSiblings(el)

    await patch(url, {
      body: { position },
      responseKind: 'json',
    })

    const frame = this.element.closest('turbo-frame')
    const newUrl = this.urlValue

    if (frame) {
      /*
       * First time: we need to set the `src` attribute,
       * as the frame would not know what to reload.
       *
       * Subsequent loads: setting the `src` attribute would have
       * not effect, we need to call `reload()`.
       */
      // eslint-disable-next-line consistent-return
      if (frame.src === newUrl) return frame.reload()
      frame.src = newUrl
    } else {
      window.Turbo.visit(newUrl)
    }
  }

  #destroySortable() {
    if (this.sortable) {
      this.sortable.destroy()
      delete this.sortable
    }
  }
}
